import React from "react";

const HelpPage = () => {
  return (
    <div id="help" className="p-6">
      <h2 className="text-2xl font-bold mb-4">Help &amp; Documentation</h2>
      <p className="text-gray-600">
        This section will provide guidance on using the dashboard and code
        generator.
      </p>
    </div>
  );
};

export default HelpPage;
